import React from 'react';
import SessionStorageConst from '../../blocks/consts/SessionStorageConst';
import { Language } from '../../blocks/localization/Language';
import { TERMS_PDF_URL } from '../../config';
import I18n from '../../blocks/localization';

interface Props {
    height: string;
}

const TermsOfUseContent = (props: Props) => {
    const language = sessionStorage.getItem(SessionStorageConst.Language) as Language;
    const pdfUrl = TERMS_PDF_URL[language];

    const getUrl = (): string => {
        return `https://drive.google.com/viewerng/viewer?embedded=true&url=${pdfUrl}`;
    }

    return (
        <>
            <a href={pdfUrl} target="_blank">{`${I18n.t('termsOfUse.title')}.pdf`}</a>
            <embed src={getUrl()} width="100%" height={props.height} />
        </>
    );
}

export default TermsOfUseContent;
